import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ButtonOutlined, ButtonRectangle } from "components/views/form/Button";
import { Link } from "react-router-dom";
import { ReactComponent as IcIturinCoverage } from 'assets/icons/ic-iturin-coverage.svg';

type Props = {
    isWebView: boolean;
    handleErrorTicketOpen: (showError: boolean) => void;
  };
  
  const PageErrorPendingTicket = ({
    isWebView,
    handleErrorTicketOpen,
  }: Props) => {
    return(
    <Box sx={{ textAlign: 'center', alignItems: 'center', width: '100%', 'svg': { maxHeight: '114px' } }}> 
                    <IcIturinCoverage />
                    <Typography lineHeight='20px' sx={{
                        fontSize: { xs: '1rem', md: '1.25rem' }
                    }}>
                        Para prosseguir <b>você precisa</b> realizar o
                        pagamento do(s) boleto(s) em aberto.
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: { xs: '1rem', md: '1.25rem' },
                            paddingTop: { xs: '.68rem', md: '1.125rem' }
                        }}>
                        {isWebView ?
                            <>Acesse suas <b>faturas</b> através do menu <br /> inferior do app.</>
                            :
                            <>
                                Deseja pagar agora?&nbsp;
                                <Link
                                    to="/faturas"
                                    style={{ color: '#17A7E0', textDecoration: 'underline', fontWeight: 700 }}
                                    onClick={() => handleErrorTicketOpen(false)}
                                >
                                    clique aqui.
                                </Link>
                            </>
                        }
                    </Typography>
                    <Typography sx={{
                        fontSize: { xs: '1rem', md: '1.25rem' },
                        paddingTop: { xs: '2rem', md: '2.93rem' }
                    }}>
                        Ou se preferir entre em contato:
                    </Typography>

                    <Box sx={{ width: '100%', maxWidth: '20rem', margin: '1.25rem auto 0', 'button': { width: '100%', marginBottom: '.93rem' } }}>
                        <Typography fontSize='.75rem' fontWeight={700} marginBottom='.5rem'>
                            Digite a opção 1
                        </Typography>
                        {isWebView ?
                            <Typography fontSize='.92rem' color='primary.main' marginBottom='.5rem' textAlign='center'>
                                    Fale Conosco - <b>(11) 3616-9000</b>
                            </Typography>                          
                            :
                            <ButtonRectangle name='WHATSAPP' onClick={() => { window.open('https://api.whatsapp.com/send/?phone=551136169000', '_target'); handleErrorTicketOpen(false); }} />
                        }
                        {!isWebView &&
                            <ButtonOutlined name='CENTRAL DE ATENDIMENTO' onClick={() => { window.open('tel:1136169000', '_target'); handleErrorTicketOpen(false); }} />
                        }
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: { xs: '1rem 0 .75rem', md: '2rem 0 .75rem' } }}>
                        <Typography fontSize='1rem' color='white' fontWeight={700} padding='9px 2.125rem 4px' sx={{ backgroundColor: 'primary.light', width: 'fit-content', marginBottom: '5px' }}>
                            IMPORTANTE:
                        </Typography>
                        <Typography lineHeight='19px' textAlign='center' sx={{ width: { xs: 'fit-content', md: '405px' }, border: '1.4px solid #17A7E0', borderRadius: '5px', padding: { xs: '.875rem 0', md: '.875rem .75rem .75rem' }, fontSize: { xs: '.875rem', md: '1rem' } }}>
                            As informações do seu processo de troca ficam
                            armazendas <strong>aqui.</strong> Caso seja interrompido volte e
                            conclua a sua troca de onde parou.
                        </Typography>
                    </Box>
                    <Link to={`${isWebView ? '/wb' : ''}/central-de-trocas`} style={{ color: '#0C1C33', textDecoration: 'underline', fontWeight: 700 }} onClick={() => handleErrorTicketOpen(false)}>
                        SAIR
                    </Link>
                </Box>
    )
}

export default PageErrorPendingTicket;